/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import {
  Card,
  CardContent,
  Autocomplete,
  createFilterOptions,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
  },
  content: {
    paddingLeft: theme.spacing(3),
  },
  contentVersion: {
    marginRight: theme.spacing(2),
  },
}));

function EvaVersionCard(props) {
  const {
    data,
    autoCompleteData,
    mode,
    type,
    isViewMode,
    onComplete,
    className,
    ...rest
  } = props;
  const classes = useStyles();

  const handleAutocompleteChange = (event, value) => {
    data.version = value;
    onComplete(Object.assign({}, data));
  };
  const { t } = useTranslation();

  return (
    <Card variant="outlined" className={classes.root}>
      <CardContent className={classes.content}>
        <b className={classes.contentVersion}>Version</b>
        {(autoCompleteData || []).length > 0 ? (
          <Autocomplete
            size="small"
            disabled={isViewMode}
            options={autoCompleteData}
            disablePortal
            getOptionLabel={(option) => option.versionName || ""}
            isOptionEqualToValue={(option, value) =>
              option.mainVersionID === value.mainVersionID
            }
            filterOptions={createFilterOptions({
              limit: 20,
            })}
            value={data.version || {}}
            renderInput={(params) => <TextField size="small" {...params} />}
            onChange={handleAutocompleteChange}
          />
        ) : (
          data.versionName
        )}
        <br />
        <b>{t("VendorSelf.esgFormName")}</b>
        <br />
        <div>{data.esgFormName}</div>
        <b>{t("VendorSelf.detail")}</b>
        <br />
        <div
          className={classes.content}
          dangerouslySetInnerHTML={{
            __html: data.esgFormDetail || "",
          }}
        ></div>
      </CardContent>
    </Card>
  );
}

EvaVersionCard.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object,
  mode: PropTypes.string,
  isViewMode: PropTypes.bool,
};

export default EvaVersionCard;
